// extracted by mini-css-extract-plugin
export var adjacentSlide = "_n3-9";
export var arrowButtonContainer = "_n3-5";
export var arrowButtonIcon = "_n3-6";
export var carouselArrowButton = "_n3-2";
export var carouselElementContainer = "_n3-1";
export var currentSlide = "_n3-8";
export var left = "_n3-3";
export var otherSlide = "_n3-a";
export var productCarouselContainer = "_n3-0";
export var right = "_n3-4";
export var sliderOverflow = "_n3-7";